import { DiscountType } from "@/api/discount/types";

import { DispenserBase } from "./dispensers";
import { ProductBase } from "./products";

export enum DeliveryUserNotification {
  SHIPPING_DELAY = "shipping_delay",
  SHIPPED = "shipped",
  DELIVERY_DELAY = "delivery_delay",
  DELIVERY_DELIVERED = "delivery_delivered",
}

export enum DeliveryStage {
  NOT_BOOKED = "not-booked",
  BOOKED = "booked",
  EN_ROUTE = "en-route",
  DELIVERED = "delivered",
  FAILED = "failed",
  UNKNOWN = "unknown",
}

export interface DeliveryEvent {
  stage: DeliveryStage;
  date?: string;
}

export interface Delivery {
  carrot_booked: boolean;
  checkout_id: number;
  discount_percent: number;
  discount_value: number;
  discount_type: DiscountType;
  created: string;
  delivery_date_original: string;
  delivery_date: string;
  delivery_window_end_original: string;
  delivery_window_end: string;
  delivery_window_start_original: string;
  delivery_window_start: string;
  dispensers: DispenserBase[];
  events: DeliveryEvent[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  helthjem_booking_response: any;
  helthjem_id: string;
  home_stock_updated: boolean;
  id: number;
  products: ProductBase[];
  shipping_date_original: string;
  shipping_date: string;
  stage: DeliveryStage;
  user_notifications: DeliveryUserNotification[];
  warehouse_notified: boolean;
  trackingReference: string[];
}
